<template>
  <div
    class="card card-body h-full hover:shadow-md transition-shadow cursor-pointer"
  >
    <div class="flex items-start justify-between gap-2 mb-2.5">
      <div>
        <div class="font-heading font-bold text-[14px]">{{ card.name }}</div>
        <div class="text-[12px] text-gray-500 dark:text-dark-text-muted mt-0.5">
          {{ card.desc }}
        </div>
      </div>
      <span class="badge badge-live flex-shrink-0">● Live</span>
    </div>
    <div class="flex gap-1.5 flex-wrap mb-2.5">
      <span
        v-for="(b, i) in card.badges"
        :key="b"
        class="badge"
        :class="i === 0 ? 'badge-teal' : 'badge-gray'"
        >{{ b }}</span
      >
    </div>
    <div class="flex gap-1.5 flex-wrap mb-2.5">
      <span
        v-for="d in card.dims"
        :key="d"
        class="badge text-[10px]"
        :class="dimClass(d)"
        >{{ d }}</span
      >
    </div>
    <div class="flex gap-2 text-[11px] text-gray-400 dark:text-dark-text-muted">
      <span>📨 {{ card.meta }}</span
      ><span>·</span><span>{{ card.edited }}</span>
    </div>
  </div>
</template>

<script setup>
import { DIM_CHIP_CLASS } from "../sms-config";

defineProps({
  card: { type: Object, required: true }
});

function dimClass(d) {
  return DIM_CHIP_CLASS[d] || "";
}
</script>
